import './App.css';
import Kumar from './Title/Title1';
import Boddy from './Card1/Body1';
import What from './card2/Secondpage';
import Diversityy from './card3/Diversity';
import Stakeholders from './card4/Stakeholder';
import Services from './card5/Service';
import Lastpage from './card6/Endpage';


function App() {
  return (
    <div className="App">
      <Kumar />
      <Boddy />
      <What />
      <Diversityy />
      <Stakeholders />
      <Services />
      <Lastpage />
    </div>
  );
}

export default App;